import React from 'react';

import { IHeaderEnhancedProps } from '../interface';
import { NavigationMenuContainer } from './NavigationMenuContainer';
import { BurgerButton } from './BurgerButton';

import { Logo } from './Logo';
import { __ } from '../../../../utils/translation-service';
import styled from '@emotion/styled';
import { PhoneFilledIcon } from './Icons/PhoneFilledIcon';

const HeaderStyled = styled.header`
    display: flex;
    align-items: center;
    padding: 6px 16px;
    background-color: ${({ theme }) => theme.colorsUnifications.white[100]};
`;

const LogoWrapper = styled.div`
    max-width: 110px;
    @media (max-width: 340px) {
        display: none;
    }
`;

const ContactBlockWrapper = styled.div`
    display: flex;
    flex-direction: column;
    align-items: end;
    flex-grow: 1;
`;

const ContactBlockTitle = styled.div`
    color: ${({ theme }) => theme.headerContacts.titleColor};
    font-size: 10px;
    font-weight: 700;
    white-space: nowrap;
    margin-bottom: 4px;
`;

const ContactBlockPhone = styled.div`
    display: flex;
    align-items: center;
`;

const ContactBlockPhoneNumber = styled.a`
    color: ${({ theme }) => theme.headerContacts.phoneColor};
    font-size: 18px;
    font-weight: 700;
    text-decoration: none;
    &:hover,
    &:active,
    &:visited {
        color: ${({ theme }) => theme.headerContacts.phoneColor};
        text-decoration: none;
    }
`;

const PhoneIconStyled = styled(PhoneFilledIcon)`
    color: ${({ theme }) => theme.icon.brandColor1};
    fill: ${({ theme }) => theme.icon.brandColor1};
    margin-right: 4px;
    width: 16px;
    height: 16px;
`;

interface IState {
    isOpen: boolean;
}

interface IHeaderMobileProps extends IHeaderEnhancedProps {
    device: string;
}

export class Header extends React.Component<IHeaderMobileProps, IState> {
    public constructor(props: IHeaderMobileProps) {
        super(props);
        this.state = {
            isOpen: false,
        };
    }

    public handleClickOpenMenu = () => this.setState({ isOpen: true });
    public handleClickCloseMenu = () => this.setState({ isOpen: false });

    public render() {
        const { device, phoneNumber, hideMenu } = this.props;

        return (
            <HeaderStyled>
                {!hideMenu && <BurgerButton onClick={this.handleClickOpenMenu} />}
                <LogoWrapper>
                    <Logo isMobile={device === 'mobile'} />
                </LogoWrapper>
                <ContactBlockWrapper>
                    <ContactBlockTitle>{__('callustitle')}</ContactBlockTitle>

                    <ContactBlockPhone>
                        <PhoneIconStyled width={20} height={20} />
                        <ContactBlockPhoneNumber
                            href={`tel:${phoneNumber}`}
                            dangerouslySetInnerHTML={{ __html: phoneNumber }}
                        />
                    </ContactBlockPhone>
                </ContactBlockWrapper>
                {!hideMenu && (
                    <NavigationMenuContainer
                        closeMenuClick={this.handleClickCloseMenu}
                        isOpen={this.state.isOpen}
                        header={this.props.items}
                        appConfig={this.props.appConfig}
                        brandConfig={this.props.brandConfig}
                        config={this.props.config}
                    />
                )}
            </HeaderStyled>
        );
    }
}
